var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{on:{"change":function($event){return _vm.$emit('input', $event.target.value);}}},_vm._l((_vm.data),function(str){return _c('option',{key:str.id,domProps:{"value":str.id,"innerHTML":_vm._s(str.title)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }